import ChecBox from '@/compoments/common/ChecBox'
import { useUpdateMeMutation } from '@/services/auth'
import { yupResolver } from '@hookform/resolvers/yup'
import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import * as yup from 'yup'
import { type InferType } from 'yup'

const schema = yup.object().shape({
    new_task: yup.boolean(),
    message_from_client: yup.boolean(),
    message_from_manager: yup.boolean(),
    analytics: yup.boolean(),
})

type FormType = InferType<typeof schema>

const NotificationSettings = () => {
    const { user, activeRole } = useSelector((state: any) => state.auth)
    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm<FormType>({
        mode: 'onChange',
        // defaultValues: {
        //     twoFactorAuthentication: user?.twoFactorAuthentication || '',
        // },
        resolver: yupResolver(schema),
    })

    useEffect(() => {
        if (!user) return
        setValue('new_task', user?.notifications?.includes('new_task'))
        setValue(
            'message_from_client',
            user?.notifications?.includes('message_from_client'),
        )
        setValue(
            'message_from_manager',
            user?.notifications?.includes('message_from_manager'),
        )
        setValue('analytics', user?.notifications?.includes('analytics'))
    }, [user])

    const [updateMe] = useUpdateMeMutation()
    const onSubmit = async (data: FormType) => {
        const formData = new FormData()

        const result = Object.entries(data)
            .filter(([key, value]) => value === true)
            .map(([key]) => key)

        formData.append('notifications', JSON.stringify(result))

        try {
            const res = await updateMe(formData)

            console.log(res, 'res')

            if (res?.data?.success) {
                toast.success('Updated successfully!')
            } else {
                toast.error(res?.data?.message || 'Something went wrong')
            }
        } catch (error) {
            toast.error('Something went wrong')
            console.error('rejected', error)
        }
    }

    return (
        <div className="settings-body">
            <div className="settings__header ">
                <h4 className="mb-22">Notification Settings</h4>
                <button
                    type="submit"
                    onClick={handleSubmit(onSubmit)}
                    className="btn btn--primary-gradient btn--lg fullRadius mb-22"
                >
                    <span className="text--md">Save Changes</span>
                </button>
            </div>

            <div className="row gy-42">
                {/* <div className="col-lg-5">
                    <h5 className="mb-13">Two-Factor Authentication</h5>
                </div> */}
                <div className="col-12">
                    <div className="form-group--row input--lg mb-22">
                        <ChecBox
                            type="checkbox"
                            label="New Tasks"
                            text="Tell me about new tasks that I get."
                            {...register('new_task')}
                        />
                    </div>
                    <div className="form-group--row input--lg mb-22">
                        <ChecBox
                            type="checkbox"
                            label="Messages From Client"
                            text="Tell me about new messages from clients."
                            {...register('message_from_client')}
                        />
                    </div>
                    <div className="form-group--row input--lg mb-22">
                        <ChecBox
                            type="checkbox"
                            label="Messages From Manager"
                            text="Tell me about new messages from manager."
                            {...register('message_from_manager')}
                        />
                    </div>
                    <div className="form-group--row input--lg mb-22">
                        <ChecBox
                            type="checkbox"
                            label="Analytics"
                            text="Tell me new information in my analytics."
                            {...register('analytics')}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NotificationSettings
